import React, {Dispatch, SetStateAction, useEffect, useState} from 'react'
import {FilterNonprofitsProps} from './filter-non-profits.constants'
import {ScreenSize} from '../../settings/device'
import { NonprofitCategory } from '../../models'
import { keyDownEvents, keyPressEvents } from '../../store/types'

export type ItemStateValueType = {
  state: string
  value: number
}

type useFilterNonprofitsHookProps = FilterNonprofitsProps
type useFilterNonprofitsHookType = FilterNonprofitsProps & {
  onFocus: boolean
  drawerStatus: boolean
  btnDisabled: boolean
} & {
  isApply: () => boolean
  handleChangeCategoryHandler: (value: any) => void
  searchTextFieldBlurHandler: () => void
  searchTextFieldEnterHandler: (value: React.KeyboardEvent) => void
  searchTextFieldFocusHandler: () => void
  handleSearchTextHandler: (value: string) => void
  toggleDrawer: (
    open: boolean
  ) => (event: React.KeyboardEvent | React.MouseEvent) => void | undefined
  applyBtnHandler: () => void
} & {
  setOnfocus: Dispatch<SetStateAction<boolean>>
  setDrawerStatus: Dispatch<SetStateAction<boolean>>
  setBtnDisabled: Dispatch<SetStateAction<boolean>>
}

export const useFilterNonprofitsHook = (props: useFilterNonprofitsHookProps): useFilterNonprofitsHookType => {
  const {
    screenSize,
    onFilterChanged,
    loading,
    cancelHandler,
    categories,
    nonprofitCategoryId,
    searchText,
    setFilterCollapsed,
    isFilterCollapsed,
    settings,
  } = props

  useEffect(() => {
    if (screenSize === 1) {
      setFilterCollapsed(false)
    }
  }, [])

  const [btnDisabled, setBtnDisabled] = useState<boolean>(true)
  const [onFocus, setOnfocus] = useState<boolean>(false)
  const [drawerStatus, setDrawerStatus] = useState<boolean>(false)
  const [, setInitialSearchState] = useState<string>(searchText)

  /*Param that defined reload*/
  const isApply = () => {
    return screenSize !== ScreenSize.Mobile
  }

  /*Select Category Handler */
  const handleChangeCategoryHandler = (value: any) => {
    setBtnDisabled(false)
    onFilterChanged(
      {
        nonprofitCategoryId:
          (value as NonprofitCategory) && value.nonprofitCategoryId
            ? value.nonprofitCategoryId
            : null,
      },
      isApply(),
      true
    )
  }

  /* Search Text Blur Handler */
  const searchTextFieldBlurHandler = () => {
    setOnfocus(false)

    onFilterChanged({ searchText }, isApply(), true)
  }
  
  const searchTextFieldEnterHandler = (data: React.KeyboardEvent) => {
    if (data.code === 'Enter') {
      searchTextFieldBlurHandler()
    }
  }
  
  /*Search Text Focus Handler*/
  const searchTextFieldFocusHandler = () => {
    setInitialSearchState(searchText)
    setOnfocus(true)
  }

  /* Search Text Handler */
  const handleSearchTextHandler = (value: string) => {
    const searchText = value

    setBtnDisabled(false)
    onFilterChanged(
      {
        searchText, //searchText: value as string
      },
      false
    )
  }


  /*DrawerManager*/
  const toggleDrawer =
  (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event &&
      event.type === keyPressEvents.keydown &&
      ((event as React.KeyboardEvent).key === keyDownEvents.tab ||
        (event as React.KeyboardEvent).key === keyDownEvents.shift)
    ) {
      return
    }
    setDrawerStatus(open)
  }

  /*Apply Btn Button*/
  const applyBtnHandler = () => {
    setDrawerStatus(false)
    onFilterChanged({}, true, true)
    setBtnDisabled(true)
  }

  return {
    //props
    searchText,
    screenSize,
    onFilterChanged,
    loading,
    cancelHandler,
    categories,
    nonprofitCategoryId,
    setFilterCollapsed,
    isFilterCollapsed,
    settings,

    //methods
    isApply,
    handleChangeCategoryHandler,
    searchTextFieldBlurHandler,
    searchTextFieldEnterHandler,
    searchTextFieldFocusHandler,
    handleSearchTextHandler,
    toggleDrawer,
    applyBtnHandler,

    //state
    onFocus,
    btnDisabled,
    drawerStatus,

    //state methods
    setOnfocus,
    setDrawerStatus,
    setBtnDisabled
  }
}